<template>
  <v-skeleton-loader
    :loading="isLoading"
    :type="`list-item-two-line@5`"
    style="border-radius: 10px;"
  >
    <v-card
      class="overflow-hidden rounded-lg"
      :flat="isFlat"
    >
      <v-card-title class="text-subtitle-1 grey lighten-2">
        Champs obligatoires
      </v-card-title>

      <v-list
        dense
        light
        class="py-0"
        flat
      >
        <div
          v-for="(fields, panelName, index) in mandatoryFields"
          :key="index"
        >
          <v-divider
            v-if="index > 0"
          />
          <v-subheader class="font-weight-black">
            {{ panelName }}
          </v-subheader>
          <v-list-item-group>
            <v-list-item
              v-for="(field, fieldIndex) in fields"
              :key="fieldIndex"
              @click="$emit('scroll-to-field', field.name)"
            >
              <v-list-item-icon>
                <v-icon small>
                  mdi-link-variant
                </v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ field.label }}*</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </div>
      </v-list>
    </v-card>
  </v-skeleton-loader>
</template>

<script>
export default {
  name: 'MandatoryFieldsSection',
  props: {
    mandatoryFields: {
      type: Object,
      required: true
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    isFlat: {
      type: Boolean,
      default: false
    }
  }
};
</script>
